import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-social.module.scss"
import CopyContainer from "../../atoms/copy-container"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"

const NewsletterSocial = ({ section, styling }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)

  return (
    <div className={styling === "lifestyle" ? styles.grid__lifestyle : ""}>
      {section.title ? (
        <div className={styling === "lifestyle" ? styles.title__lifestyle : ""}>
          {section.icon ? (
            <div className={styles.icon}>
              <Image {...section.icon?.image} width={60} height={60} alt="" />
            </div>
          ) : (
            ""
          )}
          <div className={styles.titleInner}>
            {section.partner ? (
              <Heading level={6}>
                {section.partner.prefix ||
                  allSanityDictionary.nodes.find(
                    (item) => item.key.current === "partner_feature"
                  )?.value}{" "}
                {section.partner.name}
              </Heading>
            ) : (
              ""
            )}
            {section.subtitle && !section.partner ? (
              <Heading level={6}>{section.subtitle}</Heading>
            ) : (
              ""
            )}
            {styling === "lifestyle" ? (
              <div className={styles.titleText}>{section.title}</div>
            ) : (
              <Heading level={4}>{section.title}</Heading>
            )}
          </div>
          {section.icon ? (
            <div className={styles.icon}>
              <Image {...section.icon?.image} width={60} height={60} alt="" />
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      {section._rawDescription ? (
        <CopyContainer
          className={styles.description}
          content={section._rawDescription}
        />
      ) : (
        ""
      )}
      <Grid nowrap tight col={section.posts.length}>
        {section.posts.map((post) => (
          <div
            className={styling === "lifestyle" ? styles.post__lifestyle : ""}
          >
            {post.title ? <Heading level={4}>{post.title}</Heading> : ""}
          </div>
        ))}
      </Grid>
      <Grid nowrap tight col={section.posts.length}>
        {section.posts.map((post) => (
          <div
            className={styling === "lifestyle" ? styles.post__lifestyle : ""}
          >
            <a
              className={styles.imageLink}
              href={post.url}
              target="_blank"
              rel="noreferrer"
            >
              <Image
                className={`${styles.image} ${styling === "lifestyle" ? styles.image__lifestyle : ""}`}
                {...post.image}
                width={400}
                alt={post.caption}
              />
            </a>
          </div>
        ))}
      </Grid>
      <Grid nowrap tight col={section.posts.length}>
        {section.posts.map((post) => (
          <div
            className={styling === "lifestyle" ? styles.post__lifestyle : ""}
          >
            <div
              className={`${styles.caption}
            ${styling === "lifestyle" ? styles.caption__lifestyle : ""}`}
            >
              {post.caption}
            </div>
          </div>
        ))}
      </Grid>
    </div>
  )
}

export default NewsletterSocial

NewsletterSocial.propTypes = {
  section: PropTypes.object.isRequired,
  styling: PropTypes.string,
}

NewsletterSocial.defaultProps = {
  styling: "",
}
